import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Memoize } from '@app/providers/utils/memoize-decorator';
import * as _ from 'lodash';

import { Subject, catchError } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'assessment-assets-incomeform',
    templateUrl: './assessment-assets-incomeform.component.html',
    styleUrls: ['./assessment-assets-incomeform.component.scss'],
    standalone: false
})
export class AssessmentAssetsIncomeformComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  subscriptions: any[] = [];

  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);

    this.form.controls['amount'].setValue(
      this.computeDefaultAnnualIncomeAmount(),
    );
  }
  get totalAllocated() {
    return this.getTotal(this.form.value);
  }
  computeDefaultAnnualIncomeAmount() {
    const pledge: any = this.subscriptionFacade.getPledge();
    const { amount } = pledge?.parameters?.earningsRepartition || {};
    if (amount) {
      return amount;
    } else if (pledge?.owners?.length > 0) {
      const incomeValue = pledge?.owners?.[0].incomeValue;
      return incomeValue && incomeValue > 0 ? incomeValue : 0;
    }
    return 0;
  }
  floored(value) {
    return Math.round(value * 100) / 100;
  }
  get repartition() {
    return this.form.value;
  }
  getTotal(FormValue) {
    const amount = _.pick(FormValue, [
      'salaryOrRetirement.percent',
      'propertyIncome.percent',
      'bicIncome.percent',
      'movableIncome.percent',
      'bncIncome.percent',
      'baIncome.percent',
    ]);
    if (!_.values(amount).length) return 0;
    return (
      this.floored(
        _.chain(
          _.sum(_.values(amount).map(el => parseFloat(el?.percent) || 0)),
        ).value(),
      ) / 100
    );
  }

  @Memoize(true)
  allocationPanel(totalAllocated) {
    if (totalAllocated > 1)
      return {
        display: 'danger',
        icon: 'error',
        text: `${Math.round(
          totalAllocated * 100,
        )}% au total - Vous ne pouvez pas repartir plus de 100% `,
      };
    else if (totalAllocated < 1)
      return {
        display: 'warning',
        icon: 'warning',

        text: `Il vous reste ${Math.round(
          (1 - totalAllocated) * 100,
        )}% à répartir`,
      };
    else if (totalAllocated == 1)
      return {
        display: 'success',
        icon: 'check',
        text: 'Félicitations, vos revenus sont répartis à 100%',
      };
  }

  onSubmit() {
    this.form.markAsDirty();
    this.displayErrors();
    if (this.shouldSavePledge()) {
      const pledge = this.subscriptionFacade.getPledge();
      this.updatePledgeParameters(pledge);
      this.savePledge(pledge);
    }
  }
  private updatePledgeParameters(pledge: PledgeRead) {
    const { parameters } = pledge || {};
    const { amount } = parameters?.earningsRepartition || {};
    pledge.parameters = {
      ...parameters,
      ...this.extract(),
    };
    this.setOwnerIncomeValue(pledge, amount);
  }
  private setOwnerIncomeValue(pledge: PledgeRead, amount: number) {
    if (pledge?.owners?.[0]) pledge.owners[0].incomeValue = amount;
  }

  private shouldSavePledge() {
    return this.totalAllocated == 1 && this.form.valid;
  }
  private savePledge(pledge: PledgeRead) {
    this.loading = true;
    this.subscriptionFacade
      .putPledge({ ...pledge })
      .pipe(
        untilDestroyed(this),

        catchError(err => {
          this.handleError();
          return err;
        }),
      )
      .subscribe(data => {
        this.handleSuccess();
      });
  }

  private handleError() {
    this.loading = false;
    this.notificationService.error('La sauvegarde a échoué');
  }

  private handleSuccess() {
    this.loading = false;
    this.subscriptionFacade.nextStep();
  }
  prev() {
    this.subscriptionFacade.previousStep();
  }
}
